import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types/content';
import { formatDate } from '@/lib/content';

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <article className="group h-full rounded-lg border border-background-200/80 bg-background-50 overflow-hidden flex flex-col hover:border-primary-300 transition-colors">
      <Link to={`/detail/news/${item.id}`} className="block cursor-pointer">
        <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 琉璃神社动漫资讯`}
            className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
          />
          <span className="absolute left-3 top-3 px-2 py-1 rounded bg-accent-500 text-primary-950 text-[11px] leading-none">
            {item.section}
          </span>
        </div>
      </Link>
      <div className="flex flex-col flex-1 p-4 md:p-5">
        <div className="flex items-center gap-2 text-[11px] text-secondary-500 font-label tracking-wide">
          <span>{formatDate(item.date)}</span>
          <span className="w-1 h-1 rounded-full bg-background-400"></span>
          <span className="truncate">{item.author}</span>
        </div>
        <h3 className="mt-2.5 text-[15px] md:text-base font-semibold leading-7">
          <Link
            to={`/detail/news/${item.id}`}
            className="hover:text-primary-700 transition-colors cursor-pointer clamp-2"
          >
            {item.title}
          </Link>
        </h3>
        <p className="mt-2 text-sm text-secondary-600 leading-6 clamp-2">{item.summary}</p>
        <div className="mt-4 pt-3 border-t border-background-200/70 flex items-center justify-between">
          <span className="text-[11px] text-secondary-500 inline-flex items-center gap-1">
            <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
            {item.views.toLocaleString('en-US')}
          </span>
          <Link
            to={`/detail/news/${item.id}`}
            className="text-xs text-primary-600 hover:text-accent-600 transition-colors inline-flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            阅读全文
            <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}